var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-business-content"},[_c('h3',{staticClass:"main-business-title"},[_vm._v(_vm._s(_vm.details.title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.details.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77cfbc3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mainBusiness.vue
// module id = null
// module chunks = 